import { createContext, useContext } from "react";

type OpenOptimizationDetail = (optimizationId: string) => void;

const OptimizationDetailContext = createContext<OpenOptimizationDetail | undefined>(undefined);

export const OptimizationDetailProvider = OptimizationDetailContext.Provider;

export const useOpenOptimizationDetail = () => useContext(OptimizationDetailContext);
